// Action mappers =====
export const UPDATE_SLOT_FILTER = 'UPDATE_SLOT_FILTER';

// Upcoming / Past slots list view
export const FETCH_SLOTS_REQUEST = 'FETCH_SLOTS_REQUEST';
export const FETCH_SLOTS_SUCCESS = 'FETCH_SLOTS_SUCCESS';
export const FETCH_SLOTS_FAILURE = 'FETCH_SLOTS_FAILURE';

// Pagination for infinite scroll
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const FETCH_MORE_SLOTS_REQUEST = 'FETCH_MORE_SLOTS_REQUEST';
export const FETCH_MORE_SLOTS_SUCCESS = 'FETCH_MORE_SLOTS_SUCCESS';
export const FETCH_MORE_SLOTS_FAILURE = 'FETCH_MORE_SLOTS_FAILURE';

// Single slot details view
export const FETCH_SLOT_REQUEST = 'FETCH_SLOT_REQUEST';
export const FETCH_SLOT_SUCCESS = 'FETCH_SLOT_SUCCESS';
export const FETCH_SLOT_FAILURE = 'FETCH_SLOT_FAILURE';

export const CANCEL_SLOT_REQUEST = 'CANCEL_SLOT_REQUEST';
export const CANCEL_SLOT_SUCCESS = 'CANCEL_SLOT_SUCCESS';
export const CANCEL_SLOT_FAILURE = 'CANCEL_SLOT_FAILURE';

export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';

// Load unbooked slot into state for ResourceDetails
export const LOAD_UNBOOKED_SLOT = 'LOAD_UNBOOKED_SLOT';
// =====
